export var State;
(function (State) {
    State["LOADING"] = "LOADING";
    State["SUCCESS"] = "SUCCESS";
    State["ERROR"] = "ERROR";
    State["IDLE"] = "IDLE";
})(State || (State = {}));
